import { createContext, useCallback, useContext } from 'react';

import { DossierResponseDto } from 'lib_api/lib/api/gen';

interface DossierProps {
  result: DossierResponseDto;
  setDossier: (dossier: DossierResponseDto) => void;
}

interface DossierContextContent {
  dossier: DossierProps;
}

const DossierContext = createContext<DossierContextContent | null>(null);

export const useDossierContext = (): [DossierProps] => {
  const context = useContext(DossierContext);
  if (context === null) {
    throw new Error('useDossierContext called outside Context.');
  }

  const setter = context.dossier.setDossier;
  const setDossierNonNull = useCallback(
    (dossier: DossierResponseDto) => {
      setter(dossier);
    },
    [setter],
  );

  return [{ result: context.dossier.result, setDossier: setDossierNonNull }];
};

export const DossierProvider = DossierContext.Provider;
